import React from 'react';

export function TrendingCell (props) {
    const [artist, setArtist] = React.useState('')
    const [songName, setSongName] = React.useState('')
    const [albumArt, setAlbumArt] = React.useState('')
    const track = props.track
    // React.useEffect(() => {
    //     const jsmediatags = window.jsmediatags
    //     const proxy = 'https://cors-anywhere.herokuapp.com/'
    //     const url = props.url
    //     const file = proxy+url
    //     console.log(file)
    //     jsmediatags.read(file, {
    //         onSuccess: tag => {
    //             setArtist(tag.tags.artist)
    //             setSongName(tag.tags.title)
    //              const data = tag.tags.picture.data
    //              //console.log(data)
    //              const format = tag.tags.picture.format
    //              let base64String = ''
    //              for (let i=0; i<data.length; i++) {
    //                  base64String += String.fromCharCode(data[i])
    //              }
    //              setAlbumArt(`data:${format};base64,${window.btoa(base64String)}`)
    //         },
    //         onError: error => console.log(error)
    //     })
    // },[])
    return (
        <div class = 'trendcell' onClick={props.onClick} id = {track}>
            <div id = {track ? track.url : 'no-id'} class = 'art-square' style = {{backgroundImage: track ? `url(${track.albumArt})`: 'url("https://www.seoclerk.com/pics/555434-1FzqjL1503944654.png")', backgroundSize: '100% 100%'}} ></div>
            <h5 id = {track ? track.url : 'no-id'}>{track ? track.artist : '...'}</h5>
            <h5 id = {track ? track.url : 'no-id'}>{track ? track.songName: '...'}</h5>
        </div>
    )
}